import { getSessionParams } from "./sessionStorage";
import { apiFetch } from "../../../shared/utils/http";
import { logger } from "../../../shared/utils/logger";

export const rejectSession = async (navigate: any): Promise<boolean> => {
  const storedParams = getSessionParams();

  if (!storedParams?.sessionId) {
    navigate("/error", {
      state: { errorCode: "400", errorMessage: "Session ID is missing." },
    });
    return false;
  }

  const queryParams = new URLSearchParams({
    session: storedParams.sessionId,
  }).toString();

  try {
    const response = await apiFetch(`/proxy/rejectPreview?${queryParams}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      logger.debug("Reject successful");
      return true;
    } else {
      const text = await response.text();
      logger.error("Reject failed:", response.status, text);
      return false;
    }
  } catch (error) {
    logger.error("Error during reject:", error);
    return false;
  }
};
